import PopUps from './pop-ups';

export default PopUps;
